// import React from "react";
// import { useNavigate } from "react-router-dom";

// import {
//   Paper,
//   Typography,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Box,
//   Chip,
//   TableContainer,
//   Divider,
// } from "@mui/material";

// /**
//  * JobOrderPerformance
//  * Dashboard widget showing job order stats: applicants, time to fill, stage breakdown, status.
//  * @param {Object[]} data - Array of job order performance objects
//  * @param {boolean} loading
//  * @param {string} [error]
//  */

// const getStatusChipColors = (status) => {
//   const key = String(status || "").toLowerCase();
//   if (key.includes("open") || key.includes("active")) {
//     return { bg: "rgba(34,197,94,0.12)", fg: "#15803d" };
//   }
//   if (key.includes("draft")) {
//     return { bg: "rgba(148,163,184,0.16)", fg: "#4b5563" };
//   }
//   if (key.includes("closed") || key.includes("filled")) {
//     return { bg: "rgba(148,163,184,0.16)", fg: "#374151" };
//   }
//   if (key.includes("on hold") || key.includes("paused")) {
//     return { bg: "rgba(234,179,8,0.18)", fg: "#854d0e" };
//   }
//   return { bg: "rgba(148,163,184,0.16)", fg: "#374151" };
// };

// export default function JobOrderPerformance({ data = [], loading, error }) {
//   const navigate = useNavigate();

//   function handleViewDetails(job) {
//     navigate(`/admin/job-orders/${job.id}`);
//   }

//   const hasData = Array.isArray(data) && data.length > 0;

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           mb: 1.5,
//           display: "flex",
//           alignItems: { xs: "flex-start", sm: "center" },
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <Box>
//           <Typography
//             variant="overline"
//             sx={{
//               fontSize: 11,
//               letterSpacing: 0.8,
//               textTransform: "uppercase",
//               color: "text.secondary",
//             }}
//           >
//             Performance
//           </Typography>
//           <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
//             Job Order Performance
//           </Typography>
//         </Box>
//         {hasData && (
//           <Typography
//             variant="caption"
//             color="text.secondary"
//             sx={{ whiteSpace: "nowrap" }}
//           >
//             {data.length} job{data.length > 1 ? "s" : ""}
//           </Typography>
//         )}
//       </Box>

//       <Divider sx={{ mb: 1.5 }} />

//       {/* Content */}
//       {error && (
//         <Typography
//           variant="body2"
//           color="error"
//           sx={{ mb: 1 }}
//         >
//           {error}
//         </Typography>
//       )}

//       {!hasData && !loading && !error && (
//         <Box
//           sx={{
//             py: 3,
//             textAlign: "center",
//             color: "text.secondary",
//             fontSize: 14,
//           }}
//         >
//           No job performance data yet.
//         </Box>
//       )}

//       {hasData && (
//         <TableContainer
//           sx={{
//             flex: 1,
//             overflowX: "auto",
//             maxHeight: { xs: 260, sm: 320, md: 380 },
//           }}
//         >
//           <Table
//             size="small"
//             stickyHeader
//             aria-label="job order performance table"
//           >
//             <TableHead>
//               <TableRow>
//                 <TableCell
//                   sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
//                 >
//                   Title
//                 </TableCell>
//                 <TableCell
//                   sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
//                   align="right"
//                 >
//                   Applicants
//                 </TableCell>
//                 <TableCell
//                   sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
//                 >
//                   Time to Fill
//                 </TableCell>
//                 <TableCell
//                   sx={{ fontWeight: 600, minWidth: 180 }}
//                 >
//                   Stages
//                 </TableCell>
//                 <TableCell
//                   sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
//                 >
//                   Status
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {data.map((job) => {
//                 const statusColors = getStatusChipColors(job.status);
//                 return (
//                   <TableRow
//                     key={job.id}
//                     hover
//                     sx={{
//                       cursor: "pointer",
//                       "&:last-of-type td, &:last-of-type th": {
//                         borderBottom: 0,
//                       },
//                     }}
//                     onClick={(e) => {
//                       if (
//                         e.target.closest &&
//                         (e.target.closest("button") || e.target.closest("a"))
//                       )
//                         return;
//                       handleViewDetails(job);
//                     }}
//                   >
//                     <TableCell
//                       sx={{
//                         maxWidth: 220,
//                         fontWeight: 500,
//                         whiteSpace: "nowrap",
//                         textOverflow: "ellipsis",
//                         overflow: "hidden",
//                       }}
//                     >
//                       {job.title}
//                     </TableCell>
//                     <TableCell align="right">
//                       {job.applicants}
//                     </TableCell>
//                     <TableCell
//                       sx={{ whiteSpace: "nowrap", fontSize: 13 }}
//                     >
//                       {job.time_to_fill}
//                     </TableCell>
//                     <TableCell
//                       sx={{
//                         fontSize: 12,
//                         color: "text.secondary",
//                       }}
//                     >
//                       {job.stage_counts &&
//                         Object.entries(job.stage_counts)
//                           .map(([stage, count]) => `${stage}: ${count}`)
//                           .join(", ")}
//                     </TableCell>
//                     <TableCell>
//                       <Chip
//                         label={job.status}
//                         size="small"
//                         sx={{
//                           borderRadius: 999,
//                           height: 22,
//                           fontSize: 11,
//                           fontWeight: 600,
//                           bgcolor: statusColors.bg,
//                           color: statusColors.fg,
//                           textTransform: "capitalize",
//                         }}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       )}
//     </Paper>
//   );
// }


import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Chip,
  TableContainer,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

const getStatusChipColors = (status, dark, accent) => {
  const key = String(status || "").toLowerCase();

  if (key.includes("open") || key.includes("active")) {
    return {
      bg: dark ? "rgba(34,197,94,0.18)" : "rgba(34,197,94,0.10)",
      fg: dark ? "#86efac" : "#15803d",
      border: dark ? "rgba(34,197,94,0.24)" : "rgba(34,197,94,0.18)",
    };
  }

  if (key.includes("draft")) {
    return {
      bg: dark ? "rgba(148,163,184,0.16)" : "rgba(148,163,184,0.12)",
      fg: dark ? "#cbd5e1" : "#4b5563",
      border: dark ? "rgba(148,163,184,0.24)" : "rgba(148,163,184,0.18)",
    };
  }

  if (key.includes("closed") || key.includes("filled")) {
    return {
      bg: dark ? "rgba(148,163,184,0.16)" : "rgba(148,163,184,0.12)",
      fg: dark ? "#cbd5e1" : "#374151",
      border: dark ? "rgba(148,163,184,0.24)" : "rgba(148,163,184,0.18)",
    };
  }

  if (key.includes("on hold") || key.includes("paused")) {
    return {
      bg: dark ? "rgba(245,158,11,0.18)" : "rgba(245,158,11,0.12)",
      fg: dark ? "#fcd34d" : "#854d0e",
      border: dark ? "rgba(245,158,11,0.24)" : "rgba(245,158,11,0.18)",
    };
  }

  return {
    bg: dark ? alpha(accent, 0.14) : alpha(accent, 0.08),
    fg: accent,
    border: alpha(accent, 0.2),
  };
};

export default function JobOrderPerformance({ data = [], loading, error }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const hasData = Array.isArray(data) && data.length > 0;

  function handleViewDetails(job) {
    navigate(`/admin/job-orders/${job.id}`);
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          mb: 1.75,
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              color: muted,
              fontWeight: 500,
              fontFamily:
                '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
            }}
          >
            Performance
          </Typography>
          <Typography
            sx={{
              mt: 0.6,
              fontWeight: 800,
              fontSize: "1.35rem",
              lineHeight: 1.15,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            Job Order Performance
          </Typography>
        </Box>

        {hasData && (
          <Typography
            sx={{
              fontSize: "12px",
              color: muted,
              whiteSpace: "nowrap",
            }}
          >
            {data.length} job{data.length > 1 ? "s" : ""}
          </Typography>
        )}
      </Box>

      <Divider sx={{ mb: 1.5, borderColor: border }} />

      {error && (
        <Typography sx={{ mb: 1, color: "#dc2626", fontSize: "14px" }}>
          {error}
        </Typography>
      )}

      {!hasData && !loading && !error && (
        <Box
          sx={{
            py: 3,
            textAlign: "center",
            color: mid,
            fontSize: 14,
          }}
        >
          No job performance data yet.
        </Box>
      )}

      {hasData && (
        <TableContainer
          sx={{
            flex: 1,
            overflowX: "auto",
            maxHeight: { xs: 260, sm: 320, md: 380 },
            borderRadius: "16px",
            border: `1px solid ${border}`,
          }}
        >
          <Table size="small" stickyHeader aria-label="job order performance table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                    color: mid,
                    background: dark ? "#111827" : "#fafafa",
                    borderBottom: `1px solid ${border}`,
                  }}
                >
                  Title
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                    color: mid,
                    background: dark ? "#111827" : "#fafafa",
                    borderBottom: `1px solid ${border}`,
                  }}
                >
                  Applicants
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                    color: mid,
                    background: dark ? "#111827" : "#fafafa",
                    borderBottom: `1px solid ${border}`,
                  }}
                >
                  Time to Fill
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    minWidth: 180,
                    color: mid,
                    background: dark ? "#111827" : "#fafafa",
                    borderBottom: `1px solid ${border}`,
                  }}
                >
                  Stages
                </TableCell>
                <TableCell
                  sx={{
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                    color: mid,
                    background: dark ? "#111827" : "#fafafa",
                    borderBottom: `1px solid ${border}`,
                  }}
                >
                  Status
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((job) => {
                const statusColors = getStatusChipColors(job.status, dark, accent);

                return (
                  <TableRow
                    key={job.id}
                    hover
                    sx={{
                      cursor: "pointer",
                      "& td": {
                        borderBottom: `1px solid ${border}`,
                        color: mid,
                        background: dark ? "rgba(13,18,32,0.96)" : "#ffffff",
                      },
                      "&:hover td": {
                        background: dark
                          ? "rgba(255,255,255,0.03)"
                          : "rgba(15,15,26,0.02)",
                      },
                      "&:last-of-type td, &:last-of-type th": {
                        borderBottom: 0,
                      },
                    }}
                    onClick={(e) => {
                      if (
                        e.target.closest &&
                        (e.target.closest("button") || e.target.closest("a"))
                      ) {
                        return;
                      }
                      handleViewDetails(job);
                    }}
                  >
                    <TableCell
                      sx={{
                        maxWidth: 220,
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        color: text,
                      }}
                    >
                      {job.title}
                    </TableCell>

                    <TableCell align="right">{job.applicants}</TableCell>

                    <TableCell sx={{ whiteSpace: "nowrap", fontSize: 13 }}>
                      {job.time_to_fill}
                    </TableCell>

                    <TableCell
                      sx={{
                        fontSize: 12,
                        color: mid,
                      }}
                    >
                      {job.stage_counts &&
                        Object.entries(job.stage_counts)
                          .map(([stage, count]) => `${stage}: ${count}`)
                          .join(", ")}
                    </TableCell>

                    <TableCell>
                      <Chip
                        label={job.status}
                        size="small"
                        sx={{
                          borderRadius: 999,
                          height: 24,
                          fontSize: 11,
                          fontWeight: 700,
                          bgcolor: statusColors.bg,
                          color: statusColors.fg,
                          border: `1px solid ${statusColors.border}`,
                          textTransform: "capitalize",
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
}